import { useEnv } from "@/framework/contexts/env-context";

export const useVaultDomain = () => {
  const { selectedOrg, selectedEnv } = useEnv();

  if (process.env.NODE_ENV === "development") {
    return "";
  }
  if (!selectedOrg || !selectedEnv) return null;

  return `https://app.${selectedOrg}.${selectedEnv}.repute.net`;
};
